import ClientService from '../../services/client-service';
import getBaseDataQuery from '../../graphql/query/get-base-data.graphql';
import saveUserPushNotificationTokenMutation from '../../graphql/mutation/save-user-push-notification-token.graphql';
import userSessionExpiredSubscription from '../../graphql/subscription/user-session-expired.graphql';

export default class AppApi {
  public static getBaseData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getBaseDataQuery, payload);
  }

  public static saveUserPushNotificationToken(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(saveUserPushNotificationTokenMutation, payload);
  }

  public static userSessionExpired(payload: ActionPayload, callback: Function): Promise<ApolloClientSubscription> {
    return ClientService.sendGraphqlSubscriptionRequest(userSessionExpiredSubscription, payload, callback);
  }
}
